var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgSlowHollowlands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Slow_BG_-Buildings",
    "data-name": "Slow BG -Buildings",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6131 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#281921;}.cls-3{fill:#281920;}.cls-4{fill:#2e1d26;}.cls-5{fill:#2e202a;}.cls-6{fill:#2f202b;}.cls-7{fill:#352531;}.cls-8{fill:#2e202b;}.cls-9{fill:#291921;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1954.25 1042 1902.94 1042 2178.31 825 2229.61 825 1954.25 1042"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1907.3 1205 1856 1205 1757.33 693 1808.63 693 1907.3 1205"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1748.49 1520 1697.19 1520 1856 1205 1907.3 1205 1748.49 1520"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1649.82 623 1598.52 623 1808.07 256 1859.37 256 1649.82 623"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1808.63 693 1757.33 693 1598.52 623 1649.82 623 1808.63 693"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1853.07 1799.57 1801.77 1799.57 1335.7 1799.07 1387 1799.07 1853.07 1799.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1859.37 256 1954.25 1042 2229.61 825 2083.96 1147 2084.18 1799.57 1853.07 1799.57 1387 1799.07 1748.49 1520 1907.3 1205 1808.63 693 1649.82 623 1859.37 256"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1387 1799.07 1335.7 1799.07 1697.19 1520 1748.49 1520 1387 1799.07"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3643.91 1801.21 3592.61 1801.21 3646.57 1272 3697.87 1272 3643.91 1801.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3697.87 1272 3646.57 1272 3296.07 1018 3347.37 1018 3697.87 1272"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3298.51 603 3247.2 603 3454.87 499 3506.17 499 3298.51 603"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3235.54 761 3184.24 761 3247.2 603 3298.51 603 3235.54 761"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3197.02 1801.21 3145.72 1801.21 2977.51 1344 3028.81 1344 3197.02 1801.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "3028.81 493 3235.54 761 3298.51 603 3506.17 499 3767.73 600.18 3684.72 852 3937.6 1801.21 3643.91 1801.21 3697.87 1272 3347.37 1018 3483.63 1320 3440.47 1801.21 3197.02 1801.21 3028.81 1344 3028.81 493"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2977.51,
    y: 493,
    width: 51.3,
    height: 850.99
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2253.64 445 2202.33 445 2304 87.08 2355.3 87.08 2253.64 445"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2469.76 1528 2418.46 1528 2084.87 514 2136.17 514 2469.76 1528"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "2136.17 514 2084.87 514 2202.33 445 2253.64 445 2136.17 514"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "2355.3 87.08 2279.01 581 2724.42 922 2904.84 1445 2704.14 1798.93 2238.07 1798.93 2006.97 1799.43 2184.09 1341 2469.76 1528 2136.17 514 2253.64 445 2355.3 87.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "2006.97 1799.43 1955.67 1799.43 2132.79 1341 2184.09 1341 2006.97 1799.43"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "4525.03 1212 4473.73 1212 4348.75 1017.79 4400.05 1017.79 4525.03 1212"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4306.95 1801 4255.65 1801 4473.73 1212 4525.03 1212 4306.95 1801"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "4281.65 914 4230.35 914 4391.03 815 4442.34 815 4281.65 914"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "3978.13 751 4281.65 914 4442.34 815 4684.78 998 4701.7 1371 4426.36 1643 4550.4 1801 4306.95 1801 4525.03 1212 4400.05 1017.79 4168.89 1049 4123.78 1208 3939.61 1276 3861.61 1215 3978.13 751"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "3939.61 1276 3888.3 1276 3810.3 1215 3861.61 1215 3939.61 1276"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "3861.61 1215 3810.3 1215 3926.83 751 3978.13 751 3861.61 1215"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "5228.4 1799.58 5228.37 1799.08 5228.4 1799.08 5228.4 1799.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5228.4 1799.58 5177.1 1799.58 5177.06 1799.08 5228.37 1799.08 5228.4 1799.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5458.46 1648.99 5407.15 1648.99 5166.59 1641.99 5217.89 1641.99 5458.46 1648.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "5125.8 784.99 5074.5 784.99 5279 514.15 5330.31 514.15 5125.8 784.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "4806.31 1449 4755.01 1449 4908.18 1146.99 4959.48 1146.99 4806.31 1449"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "4762.33 1799.08 4711.03 1799.08 4755.01 1449 4806.31 1449 4762.33 1799.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "4959.48 1146.99 4908.18 1146.99 4528.54 950 4579.85 950 4959.48 1146.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "5458.46 1648.99 5217.89 1641.99 5228.37 1799.08 4762.33 1799.08 4806.31 1449 4959.48 1146.99 4579.85 950 4815.71 729.99 5125.8 784.99 5330.31 514.15 5163.39 1407.99 5458.46 1648.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "4579.85 950 4528.54 950 4764.4 729.99 4815.71 729.99 4579.85 950"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "902.07 1801 850.77 1801 1056.52 1571 1107.83 1571 902.07 1801"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1107.83 1571 1056.52 1571 671.25 1052 722.55 1052 1107.83 1571"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "435.94 900 384.64 900 992.73 792.79 1044.03 792.79 435.94 900"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.82 1801 90.52 1801 235.23 1585 286.54 1585 141.82 1801"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "1044.03 792.79 1037.35 1046 1362.48 1147 1362.48 1639 1145.51 1801 902.07 1801 1107.83 1571 722.55 1052 474.47 1330 550.59 1801 141.82 1801 286.54 1585 141.82 1290 435.94 900 1044.03 792.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "286.54 1585 235.23 1585 90.52 1290 141.82 1290 286.54 1585"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.82 1290 90.52 1290 384.64 900 435.94 900 141.82 1290"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5960.68 1799.31 5909.37 1799.31 5731.45 1799 5782.75 1799 5960.68 1799.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5766.78 1638 5715.47 1638 5674.99 1528.37 5726.29 1528.37 5766.78 1638"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5782.75 1799 5731.45 1799 5674.13 1744 5725.43 1744 5782.75 1799"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5725.43 1744 5674.13 1744 5715.47 1638 5766.78 1638 5725.43 1744"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5726.29 1528.37 5674.99 1528.37 5512.5 493 5563.8 493 5726.29 1528.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "5313.85 191 5262.55 191 5575.46 -131 5626.77 -131 5313.85 191"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "5563.8 493 5512.5 493 5262.55 191 5313.85 191 5563.8 493"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "5626.77 -131 5470.77 212 5678.45 286 6161.36 1445.37 5960.68 1799.31 5782.75 1799 5725.43 1744 5766.78 1638 5726.29 1528.37 5563.8 493 5313.85 191 5626.77 -131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgSlowHollowlands);
export default __webpack_public_path__ + "static/media/bg-slow-hollowlands.9abc5832b0440b67fe3ce29723b0e11b.svg";
export { ForwardRef as ReactComponent };